(function() {
  if (window.MediaSlideshow) {
    return;
  }

  class MediaSlideshow {
    constructor(element) {
      this.element = element;
      this.wrapper = null;
      this.grid = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.items = [];
      this.currentPage = 0;
      this.totalPages = 0;
      this.itemsPerPage = 3;
      this.gap = 24;
      this.resizeObserver = null;
    }

    init() {
      console.log('MediaSlideshow init:', this.element.dataset.sectionId, this.element.className);
      console.log('Children count:', this.element.children.length);
      
      this.wrapper = this.element.querySelector('.media-slideshow__wrapper');
      this.grid = this.element.querySelector('.media-slideshow__grid');
      this.prevBtn = this.element.querySelector('.media-slideshow__scroll-btn--prev');
      this.nextBtn = this.element.querySelector('.media-slideshow__scroll-btn--next');

      console.log('wrapper:', this.wrapper);
      console.log('grid:', this.grid);
      console.log('prevBtn:', this.prevBtn);
      console.log('nextBtn:', this.nextBtn);

      if (!this.grid) {
        console.error('MediaSlideshow: .media-slideshow__grid not found in', this.element);
        console.log('Full HTML:', this.element.outerHTML);
        return;
      }

      this.items = Array.from(this.grid.querySelectorAll('.media-slideshow__item'));

      if (this.items.length === 0) return;

      this.updateItemsPerPage();
      this.calculateTotalPages();
      this.goToPage(0);
      this.addEventListeners();
      this.updateButtons();

      this.setupResizeObserver();
    }

    updateItemsPerPage() {
      const isMobile = window.innerWidth < 750;
      this.itemsPerPage = isMobile 
        ? parseInt(this.element.dataset.itemsPerPageMobile) 
        : parseInt(this.element.dataset.itemsPerPageDesktop);
    }

    calculateTotalPages() {
      this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);
    }

    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        const oldItemsPerPage = this.itemsPerPage;
        this.updateItemsPerPage();
        
        if (oldItemsPerPage !== this.itemsPerPage) {
          this.calculateTotalPages();
          this.currentPage = Math.min(this.currentPage, this.totalPages - 1);
          this.goToPage(this.currentPage);
          this.updateButtons();
        }
      });

      this.resizeObserver.observe(this.grid);
    }

    goToPage(pageIndex) {
      if (pageIndex < 0 || pageIndex >= this.totalPages) return;
      
      this.currentPage = pageIndex;
      
      const isMobile = window.innerWidth < 750;
      
      if (isMobile) {
        this.items.forEach((item) => {
          item.classList.remove('media-slideshow__item--hidden');
        });
        
        // Scroll to the correct position for mobile
        if (this.wrapper) {
          const itemWidth = this.items[0].offsetWidth;
          const scrollPosition = pageIndex * itemWidth;
          this.wrapper.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
      } else {
        const startIndex = pageIndex * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        
        this.items.forEach((item, index) => {
          if (index >= startIndex && index < endIndex) {
            item.classList.remove('media-slideshow__item--hidden');
          } else {
            item.classList.add('media-slideshow__item--hidden');
          }
        });
      }

      this.updateButtons();
    }

    nextPage() {
      const nextPageIndex = (this.currentPage + 1) % this.totalPages;
      this.goToPage(nextPageIndex);
    }

    prevPage() {
      const prevPageIndex = (this.currentPage - 1 + this.totalPages) % this.totalPages;
      this.goToPage(prevPageIndex);
    }

    updateButtons() {
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentPage === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentPage === this.totalPages - 1;
      }
    }

    addEventListeners() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prevPage());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.nextPage());
      }
    }

    removeEventListeners() {
      if (this.prevBtn) {
        this.prevBtn.removeEventListener('click', () => this.prevPage());
      }
      if (this.nextBtn) {
        this.nextBtn.removeEventListener('click', () => this.nextPage());
      }
    }
  }

  window.MediaSlideshow = MediaSlideshow;

  function initMediaSlideshows() {
    document.querySelectorAll('media-slideshow').forEach(element => {
      if (!element._mediaSlideshowInstance) {
        element._mediaSlideshowInstance = new MediaSlideshow(element);
        element._mediaSlideshowInstance.init();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMediaSlideshows);
  } else {
    initMediaSlideshows();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initMediaSlideshows);
  }
})();